export function buildFullName(user) {
  if (!user) return '';
  const parts = [user.last_name, user.first_name, user.patronymic]
    .map((item) => String(item || '').trim())
    .filter(Boolean);
  return parts.join(' ');
}

export function buildDisplayName(user) {
  const fullName = buildFullName(user);
  if (fullName) return fullName;
  return String(user?.login || '').trim();
}
